import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'typings/RootState'
import styled from 'styled-components'
import { getProjectType } from 'features/filter/api'
import { GetProjectTypeReq } from 'features/filter/types'
import { selectProjectType } from 'features/filter/selector'
import { Col, Row } from 'antd'
import {
  projectsByIdSelector,
  selectedProjectCodeSelector,
} from 'features/project/project.selector'
import {
  serviceTokenSelector,
  userEmailSelector,
} from 'features/sensitive/sensitive.selector'
import { fetchProjects } from 'features/project/project.api'
import { selectFilter } from 'features/adminReport/certificate/selector'
import { Filter } from 'features/adminReport/certificate/types'
import {
  updateFilter,
  clearFilter,
} from 'features/adminReport/certificate/actions'
import { ProjectsFilter, ProjectTypeFilter, ButtonFilter } from './Components'
import { InputSearch } from 'Components/Shared/Input'
import { PrimaryButton } from 'Components/Shared/Button'
import MulticheckProject from 'Components/Shared/Filters/MulticheckProject'
import { DropdownPopupMenu } from 'Components/Shared/Form'

type Props = {
  onSearch: (isClearFilter?: boolean) => void
  withPadding?: boolean
  percentPMR?: number
  onUpdatePercent: (percent: number) => void
  onExport?: () => void
  exportData?: any[]
  isDownLoading?: boolean
} & ReduxProps &
  DispatchProps

const CertificateFilter: React.FunctionComponent<Props> = props => {
  const {
    ProjectCode,
    UserEmail,
    token,
    filter,
    projectsById,
    onSearch = () => {},
    withPadding = false,
    projectType,
    percentPMR = 0,
    onUpdatePercent,
    onExport,
    exportData,
    isDownLoading,
  } = props

  const [percent, setPercent] = useState(0 as number)

  useEffect(() => {
    setPercent(percentPMR)
  }, [percentPMR])

  useEffect(() => {
    dispatch(clearFilter())
    onGetProjectType()
    dispatch(fetchProjects({ email: UserEmail, token }))
    return () => {
      dispatch(clearFilter())
    }
  }, [ProjectCode, UserEmail])

  const onGetProjectType = () => {
    const req: GetProjectTypeReq = {
      UserEmail,
      Page: 1,
      RowPerPage: 100,
    }
    dispatch(getProjectType(token, req))
  }

  const dispatch = useDispatch()
  const onFilterChange = (filter: Filter) => {
    dispatch(updateFilter(filter))
  }

  const onClearSearch = () => {
    dispatch(clearFilter())
    onSearch(true)
  }

  const isFilter = () => {
    return filter.ProjectCode.length > 0 || filter.ProjectTypeID !== 0
  }

  const setting = (
    <Setting>
      <Row type="flex" justify="start" align="middle">
        <Col>
          <SettingTxt>
            ตั้งค่า
            <span>% การคำนวณออกใบรับรอง น้อยกว่า</span>
          </SettingTxt>
        </Col>
        <Col span={2}>
          <InputSearch
            readOnly={false}
            placeholder=""
            value={percent.toString()}
            onChange={(value: string) => {
              let num = parseFloat(value) || 0
              if (num > 100) {
                num = 100
              }
              setPercent(num)
            }}
            hideSuffix={true}
          />
        </Col>
        <Col>
          <SettingTxt>
            <span>%</span>
          </SettingTxt>
        </Col>
        <Col span={2}>
          <PrimaryButton
            text="บันทึก"
            onClick={() => onUpdatePercent(percent)}
          />
        </Col>
      </Row>
    </Setting>
  )

  const selectedProject =
    filter.ProjectCode.length > 0
      ? `เลือก ${filter.ProjectCode.length} โครงการ`
      : ''

  return (
    <MainPage className={withPadding ? 'with-padding' : ''}>
      {setting}
      <Row type="flex" justify="start">
        <Col span={8}>
          <ProjectTypeFilter
            filter={filter}
            onFilterChange={onFilterChange}
            projectType={projectType}
          />
        </Col>
        {/* <Col span={8}>
          <ProjectsFilter
            filter={filter}
            onFilterChange={onFilterChange}
            projectsById={projectsById}
          />
        </Col> */}
        <Col span={8}>
          <DropdownPopupMenu
            label={'โครงการ'}
            placeholder="เลือกโครงการ"
            value={filter.ProjectCode.join(',')}
            disabled={false}
            content={
              <MulticheckProject
                projectList={projectsById}
                projectTypeID={filter.ProjectTypeID}
                filter={filter.ProjectCode}
                onChange={data => {
                  filter.ProjectCode = data
                  onFilterChange(filter)
                }}
              />
            }
            isActive={filter.ProjectCode.length > 0}
          />
        </Col>
        <Col span={8}>
          <ButtonFilter
            onClearSearch={onClearSearch}
            onSearch={onSearch}
            isFilter={isFilter()}
            onExport={onExport}
            isDownLoading={isDownLoading}
            exportData={exportData}
            fileName="รายงานตรวจส่วนกลาง-รายงานใบรับรองคุณภาพ"
          />
        </Col>
      </Row>
    </MainPage>
  )
}

const MainPage = styled.div`
  margin-bottom: 24px;
  &.with-padding {
    padding: 0 120px;
  }

  background-color: #f5f6fa;
`

const Setting = styled.div`
  margin-bottom: 24px;
`

const SettingTxt = styled.div`
  font-family: 'DB Helvethaica X 75 Bd';
  color: #000;
  font-size: 20px;
  width: 100%;
  padding-right: 5px;

  span {
    font-family: 'DB Helvethaica X 55 Regular';
    margin: 0 40px 0 16px;
  }
`

const mapStateToProps = (state: RootState) => {
  return {
    ProjectCode: selectedProjectCodeSelector(state),
    UserEmail: userEmailSelector(state),
    token: serviceTokenSelector(state),
    filter: selectFilter(state),
    projectType: selectProjectType(state),
    projectsById: projectsByIdSelector(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(CertificateFilter)
